import Add from "@mui/icons-material/Add";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Upload from "@mui/icons-material/Upload";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, MenuList } from "@mui/material";
import { useTenant } from "hooks/useTenant";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { AddChemicalFromSdsDialog } from "./AddChemicalFromSdsDialog";

export const AddChemicalButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const [sdsDialogOpen, setSdsDialogOpen] = useState(false);

  const { tenantId } = useTenant();

  const buttonId = "add-chemical-actions-button";

  return (
    <>
      <Button
        id={buttonId}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        onClick={handleClick}
        endIcon={<ExpandMore />}
        size="medium"
      >
        Add Chemical
      </Button>
      <Menu
        id="add-chemical-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": buttonId,
        }}
      >
        <MenuList dense>
          <MenuItem key="add" onClick={() => navigate("new")}>
            <ListItemIcon>
              <Add />
            </ListItemIcon>
            <ListItemText>Add Chemical</ListItemText>
          </MenuItem>

          <MenuItem
            key="sds-upload"
            onClick={() => {
              setSdsDialogOpen(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Upload />
            </ListItemIcon>
            <ListItemText>Add Chemical from SDS</ListItemText>
          </MenuItem>
        </MenuList>
      </Menu>

      {sdsDialogOpen && tenantId && (
        <AddChemicalFromSdsDialog
          open
          tenantId={tenantId}
          onClose={() => setSdsDialogOpen(false)}
        />
      )}
    </>
  );
};
